import { isBlank as isBlankFromLib } from 'housecall-ui/dist/common/ObjectHelper';

type EmptyObject = Record<string, never>;
type Empty = null | undefined | void;

/*
 * It is preffered to use dedicated checks for given variable types
 * (array.length for arrays etc.) instead of using this helper
 */
export const isBlank = (object: unknown): object is EmptyObject | Empty => isBlankFromLib(object);
